import { 
  Box, 
  Dialog, 
  Button, 
  DialogActions, 
  DialogContent, 
  DialogContentText, 
  DialogTitle 
} from '@mui/material';

interface Props {
  ActionType?: string;
  ActionName?: string;
  onContinueAction?: (event: any) => void;
  isConfirmActionDialogOpened?: boolean;
  setIsConfirmActionDialogOpened?: (isOpened: boolean) => void;
}

export default function ConfirmActionDialog({ 
  ActionType, 
  ActionName, 
  onContinueAction = () => {}, 
  isConfirmActionDialogOpened = false,
  setIsConfirmActionDialogOpened = () => {}, 
}: Props) {
  const handleConfirmActionDialogClose = () => {
    setIsConfirmActionDialogOpened(false);
  };
  
  return (
    <Box>
      <Dialog
        open={isConfirmActionDialogOpened}
        onClose={handleConfirmActionDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`${ActionType} Confirmation Dialog`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure you want to ${ActionType?.toLocaleLowerCase()} "${ActionName}"`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onContinueAction}>Ok</Button>
          <Button onClick={handleConfirmActionDialogClose} autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
